"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ATOM_MARKER_TYPE = exports.MARKUP_MARKER_TYPE = exports.CARD_SECTION_TYPE = exports.LIST_SECTION_TYPE = exports.IMAGE_SECTION_TYPE = exports.MARKUP_SECTION_TYPE = exports.MOBILE_DOC_VERSION_0_3_1 = exports.MOBILE_DOC_VERSION_0_3_0 = void 0;

var _react = _interopRequireDefault(require("react"));

var _v = _interopRequireDefault(require("uuid/v4"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

var MOBILE_DOC_VERSION_0_3_0 = '0.3.0';
exports.MOBILE_DOC_VERSION_0_3_0 = MOBILE_DOC_VERSION_0_3_0;
var MOBILE_DOC_VERSION_0_3_1 = '0.3.1';
exports.MOBILE_DOC_VERSION_0_3_1 = MOBILE_DOC_VERSION_0_3_1;
var MARKUP_SECTION_TYPE = 1;
exports.MARKUP_SECTION_TYPE = MARKUP_SECTION_TYPE;
var IMAGE_SECTION_TYPE = 2;
exports.IMAGE_SECTION_TYPE = IMAGE_SECTION_TYPE;
var LIST_SECTION_TYPE = 3;
exports.LIST_SECTION_TYPE = LIST_SECTION_TYPE;
var CARD_SECTION_TYPE = 10;
exports.CARD_SECTION_TYPE = CARD_SECTION_TYPE;
var MARKUP_MARKER_TYPE = 0;
exports.MARKUP_MARKER_TYPE = MARKUP_MARKER_TYPE;
var ATOM_MARKER_TYPE = 1;
exports.ATOM_MARKER_TYPE = ATOM_MARKER_TYPE;

var Renderer = /*#__PURE__*/function () {
  function Renderer(mobiledoc, _ref) {
    var _ref$atoms = _ref.atoms,
        atoms = _ref$atoms === void 0 ? [] : _ref$atoms,
        _ref$cards = _ref.cards,
        cards = _ref$cards === void 0 ? [] : _ref$cards,
        _ref$sections = _ref.sections,
        sections = _ref$sections === void 0 ? [] : _ref$sections,
        _ref$markups = _ref.markups,
        markups = _ref$markups === void 0 ? [] : _ref$markups,
        className = _ref.className,
        _ref$additionalProps = _ref.additionalProps,
        additionalProps = _ref$additionalProps === void 0 ? {} : _ref$additionalProps;

    _classCallCheck(this, Renderer);

    this.mobiledoc = mobiledoc;
    this.className = className;
    this.atoms = atoms;
    this.cards = cards;
    this.markups = markups;
    this.sections = sections;
    this.additionalProps = additionalProps;
    this.renderCallbacks = [];
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      var renderedSections = _react["default"].createElement("div", {
        className: this.className
      }, this.renderSections());

      this.renderCallbacks.forEach(function (cb) {
        return cb();
      });
      return renderedSections;
    }
  }, {
    key: "renderSections",
    value: function renderSections() {
      var _this = this;

      return this.mobiledoc.sections.map(function (section, index) {
        return _this.renderSection(section, index);
      });
    }
  }, {
    key: "renderSection",
    value: function renderSection(section, nodeKey) {
      var _section = _slicedToArray(section, 1),
          type = _section[0];

      switch (type) {
        case MARKUP_SECTION_TYPE:
          return this.renderMarkupSection(section, nodeKey);

        case LIST_SECTION_TYPE:
          return this.renderListSection(section, nodeKey);

        case CARD_SECTION_TYPE:
          return this.renderCardSection(section, nodeKey);

        default:
          return null;
      }
    }
  }, {
    key: "renderMarkupSection",
    value: function renderMarkupSection(_ref2, nodeKey) {
      var _ref3 = _slicedToArray(_ref2, 3),
          type = _ref3[0],
          TagName = _ref3[1],
          markers = _ref3[2];

      var Element;
      var customSection = this.sections.find(function (s) {
        return s.name === TagName;
      });

      if (customSection) {
        var Section = customSection.component;
        Element = _react["default"].createElement(Section, _extends({
          key: nodeKey
        }, this.additionalProps), []);
      } else {
        Element = _react["default"].createElement(TagName, {
          key: nodeKey
        }, []);
      }

      return this.renderMarkersOnElement(Element, markers);
    }
  }, {
    key: "renderListSection",
    value: function renderListSection(_ref4, nodeKey) {
      var _this2 = this;

      var _ref5 = _slicedToArray(_ref4, 3),
          type = _ref5[0],
          TagName = _ref5[1],
          markers = _ref5[2];

      var items = markers.map(function (item, index) {
        return _this2.renderMarkersOnElement(_react["default"].createElement("li", {
          key: index
        }, []), item);
      });
      return _react["default"].createElement(TagName, {
        key: nodeKey
      }, items);
    }
  }, {
    key: "renderAtomSection",
    value: function renderAtomSection(atomIndex) {
      var _mobiledoc$atoms$atom = _slicedToArray(this.mobiledoc.atoms[atomIndex], 3),
          name = _mobiledoc$atoms$atom[0],
          text = _mobiledoc$atoms$atom[1],
          payload = _mobiledoc$atoms$atom[2];

      var atom = this.atoms.find(function (a) {
        return a.name === name;
      });

      if (atom) {
        var key = "".concat(name, "-").concat(text.length);
        var env = {
          name: name,
          isInEditor: false,
          dom: 'dom'
        };
        var options = {};
        var props = {
          key: key,
          env: env,
          options: options,
          payload: _objectSpread({}, payload, this.additionalProps),
          text: text
        };
        return atom.render(props);
      }

      return null;
    }
  }, {
    key: "renderCardSection",
    value: function renderCardSection(_ref6, nodeKey) {
      var _this3 = this;

      var _ref7 = _slicedToArray(_ref6, 2),
          type = _ref7[0],
          index = _ref7[1];

      var _mobiledoc$cards$inde = _slicedToArray(this.mobiledoc.cards[index], 2),
          name = _mobiledoc$cards$inde[0],
          payload = _mobiledoc$cards$inde[1];

      var card = this.cards.find(function (c) {
        return c.name === name;
      });

      if (card) {
        var env = {
          name: name,
          isInEditor: false,
          dom: 'dom',
          didRender: function didRender(callback) {
            return _this3.registerRenderCallback(callback);
          },
          onTeardown: function onTeardown(callback) {
            return _this3.registerRenderCallback(callback);
          }
        };
        var options = {};
        var props = {
          env: env,
          options: options,
          payload: _objectSpread({}, payload, {
            key: nodeKey
          }, this.additionalProps)
        };
        return card.render(props);
      }

      return null;
    }
  }, {
    key: "renderMarkersOnElement",
    value: function renderMarkersOnElement(element, markers) {
      var _this4 = this;

      var elements = [element];

      var pushElement = function pushElement(openedElement) {
        element.props.children.push(openedElement);
        elements.push(openedElement);
        element = openedElement;
      };

      markers.forEach(function (marker) {
        var _marker = _slicedToArray(marker, 4),
            type = _marker[0],
            openTypes = _marker[1],
            closeCount = _marker[2],
            value = _marker[3]; // eslint-disable-line prefer-const


        openTypes.forEach(function (openType) {
          var _this4$mobiledoc$mark = _slicedToArray(_this4.mobiledoc.markups[openType], 2),
              TagName = _this4$mobiledoc$mark[0],
              attrs = _this4$mobiledoc$mark[1];

          var props = Object.assign({
            children: []
          }, _this4.parseProps(attrs));

          if (TagName) {
            var definedMarkup = _this4.markups.find(function (markup) {
              return markup.name === TagName;
            });

            if (definedMarkup) {
              var Markup = definedMarkup.render;
              pushElement(_react["default"].createElement(Markup, _extends({
                key: (0, _v["default"])()
              }, props, _this4.additionalProps)));
            } else {
              pushElement(_react["default"].createElement(TagName, _extends({
                key: (0, _v["default"])()
              }, props)));
            }
          } else {
            closeCount -= 1;
          }
        });

        switch (type) {
          case MARKUP_MARKER_TYPE:
            element.props.children.push(value);
            break;

          case ATOM_MARKER_TYPE:
            element.props.children.push(_this4.renderAtomSection(value));
            break;

          default:
        }

        for (var j = 0, m = closeCount; j < m; j += 1) {
          elements.pop();
          element = elements[elements.length - 1];
        }
      });
      return element;
    }
  }, {
    key: "parseProps",
    value: function parseProps(attrs) {
      if (attrs) {
        return _defineProperty({}, attrs[0], attrs[1]);
      }

      return null;
    }
  }, {
    key: "registerRenderCallback",
    value: function registerRenderCallback(cb) {
      this.renderCallbacks.push(cb);
    }
  }]);

  return Renderer;
}();

exports["default"] = Renderer;